import type { AvisoDePaciente } from '@medchoice/shared';
import type { NombreIcono } from '../../ui';

export const ICONO_AVISO: Record<AvisoDePaciente['tipo'], NombreIcono> = {
  recordatorio: 'bell', confirmacion: 'check-circle', resena: 'star', cancelacion: 'alert-circle', seguimiento: 'calendar',
};

/** Lo que el paciente puede hacer con cada aviso. */
export function accionDeAviso(a: AvisoDePaciente): { texto: string; ruta: string } {
  switch (a.tipo) {
    case 'resena': return { texto: 'Dejar reseña', ruta: `/resena/${a.id_turno}` };
    case 'cancelacion': return { texto: 'Buscar otro turno', ruta: '/buscar' };
    case 'recordatorio': return { texto: 'Ver el turno', ruta: `/turno/${a.id_turno}` };
    case 'confirmacion': return { texto: 'Ver el turno', ruta: `/turno/${a.id_turno}` };
    case 'seguimiento': return { texto: 'Reservar el control', ruta: a.id_profesional ? `/reservar/${a.id_profesional}` : '/buscar' };
  }
}
